
  import createMeisterIcons from '../src/createMeisterIcons';

  const Box = createMeisterIcons("box", [["path",{"fill":"currentColor","d":"M3.75 7c0-1.886 1.364-3.25 3.25-3.25h1.25V7.5c0 1.214 1.036 2.25 2.25 2.25h3c1.214 0 2.25-1.036 2.25-2.25V3.75H17A3.26 3.26 0 0 1 20.25 7v10A3.26 3.26 0 0 1 17 20.25H7A3.26 3.26 0 0 1 3.75 17zm10.5-3.25h-4.5V7.5c0 .386.364.75.75.75h3c.386 0 .75-.364.75-.75zM7 2.25C4.286 2.25 2.25 4.286 2.25 7v10A4.76 4.76 0 0 0 7 21.75h10A4.76 4.76 0 0 0 21.75 17V7A4.76 4.76 0 0 0 17 2.25z","key":"3f651e028d8fb9e82cb2c00114d667fd783c3e33","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Box
  